import {SET_INDICATOR} from './types';

export const setIndicator = payload => ({
  type: SET_INDICATOR,
  payload,
});
